<template>
  <div>
    <b-card-code title="Definición">
      <b-row>
        <b-col md="6">
          <b-col>
            <b-form-group label="Nombre" label-for="Name">
              <b-form-input id="Name" v-model="parameter.Name" />
            </b-form-group>
          </b-col>
        </b-col>
      </b-row>
    </b-card-code>
    <b-card-code title="Nuevos Valores">
      <b-row>
        <b-col md="6">
          <b-col>
            <b-form-group label="Factor Gratificación" label-for="Factor_Grat">
              <b-form-input id="Factor_Grat" v-model="parameter.Factor_Grat" type="number" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Factor CTS" label-for="Factor_CTS">
              <b-form-input id="Factor_CTS" v-model="parameter.Factor_CTS" type="number" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Factor Vacaciones" label-for="Factor_Vac">
              <b-form-input id="Factor_Vac" v-model="parameter.Factor_Vac" type="number" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Factor VLey" label-for="Factor_VLey">
              <b-form-input id="Factor_VLey" v-model="parameter.Factor_VLey" type="number" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Remuneración Asegurable" label-for="Rem_Asegurable">
              <b-form-input id="Rem_Asegurable" v-model="parameter.Rem_Asegurable" type="number" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Factor Incremento" label-for="Factor_Incremento">
              <b-form-input id="Factor_Incremento" v-model="parameter.Factor_Incremento" type="number" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Corte Incremento" label-for="Corte_Incremento">
              <b-form-input id="Corte_Incremento" v-model="parameter.Corte_Incremento" type="number"
                placeholder="Ejemplo: 202312" />
            </b-form-group>
          </b-col>
        </b-col>
        <b-col md="6">
          <b-col>
            <b-form-group label="Factor Asignación Familiar" label-for="Factor_AsigFam">
              <b-form-input id="Factor_AsigFam" v-model="parameter.Factor_AsigFam" type="number" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Factor Cump P var" label-for="Factor_CumpPvar">
              <b-form-input id="Factor_CumpPvar" v-model="parameter.Factor_CumpPvar" type="number" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Factor CTS P var" label-for="Factor_CTS_Pvar">
              <b-form-input id="Factor_CTS_Pvar" v-model="parameter.Factor_CTS_Pvar" type="number" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Corte Incremento Talento" label-for="Corte_Incremento_Talento">
              <b-form-input id="Corte_Incremento_Talento" v-model="parameter.Corte_Incremento_Talento" type="number"
                placeholder="Ejemplo: 202309" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Factor GST Adicional" label-for="Factor_GstAdicional">
              <b-form-input id="Factor_GstAdicional" v-model="parameter.Factor_GstAdicional" type="number" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Tipo de Cambio Ppto" label-for="TCambioPpto">
              <b-form-input id="TCambioPpto" v-model="parameter.TCambioPpto" type="number" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Factor Incremento Talento" label-for="Factor_Incremento_Talento">
              <b-form-input id="Factor_Incremento_Talento" v-model="parameter.Factor_Incremento_Talento" type="number" />
            </b-form-group>
          </b-col>
        </b-col>
      </b-row>
      <b-row>
        <!-- submit and reset -->
        <b-col md="6">
          <div>
            <b-button variant="primary" @click="save_parameter">
              <feather-icon icon="SaveIcon" class="mr-50" />
              <span class="align-middle">Guardar cambios</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card-code>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton, BFormSelect, BCardText
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import axios from '@axios'

export default {
  components: {
    BCardCode,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
    BCardText,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      parameter: {}
    }
  },
  methods: {
    printErrorModal(error) {
      this.$swal({
        title: 'Error!',
        text: error,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    save_parameter() {
      if (!this.formIsValid()) {
        this.$swal({
          title: 'Formulario Incompleto',
          text: "Por favor completa todos los campos del formulario e intenta nuevamente.",
          icon: 'error',
          confirmButtonText: 'Cerrar',
        })
        return
      }
      this.$swal({
        title: '¿Estas seguro?',
        text: "Se guardarán los cambios realizados",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, guardar cambios',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          let config = {}
          // Solo se crea 1 registro
          const URL = '/nomina/parameter'
          console.log("Iveth")
          config = {
            method: 'post', url: URL, data: { "parameter": this.parameter, "user_id": this.getUserID(), },
          }
          // Send data to server
          console.log(config)
          axios(config)
            .then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: '¡Guardado!',
                  text: 'Los parámetros han sido registrados',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(x => this.$router.push({ name: 'Parámetros' }))
              } else {
                this.printErrorModal('Error en el servidor')
              }
            })
            .catch(error => {
              this.printErrorModal(error)
            });
        }
      })
    },
    getUserID() {
      const textUserData = localStorage.getItem('userData')
      const jsonUserData = JSON.parse(textUserData)
      const id = jsonUserData.id
      return id
    },
    formIsValid() {
      if (!this.parameter.Name) return false

      if (!this.parameter.Factor_Grat) return false
      if (!this.parameter.Factor_CTS) return false
      if (!this.parameter.Factor_Vac) return false
      if (!this.parameter.Factor_VLey) return false
      if (!this.parameter.Rem_Asegurable) return false
      if (!this.parameter.Factor_Incremento) return false
      if (!this.parameter.Corte_Incremento) return false
      if (!this.parameter.Factor_AsigFam) return false
      if (!this.parameter.Factor_CumpPvar) return false
      if (!this.parameter.Factor_CTS_Pvar) return false
      if (!this.parameter.Corte_Incremento_Talento) return false
      if (!this.parameter.Factor_GstAdicional) return false
      if (!this.parameter.TCambioPpto) return false
      if (!this.parameter.Factor_Incremento_Talento) return false

      return true
    }
  },
  mounted() {
  },
  watch: {
  }
}
</script>
